import Vue from "vue";
import App from "@/App.vue";
import router from "@/routes";
import store from "@/stores";
import configuration from "@/configuration";
import "@/mixins/axios";
import "@/mixins/env";
import "@/directives/mask";
import "@/utils/inactiveMonitor";
import EventBus from "@/utils/global-events.js";
import VueClipboard from "vue-clipboard2";
import InvoiceHub from "@/hubs/invoice-hub";
import "tailwindcss/tailwind.css";
import "@/configuration/registerBaseComponents";
import VueFormulate from "@braid/vue-formulate";
import S3UploaderPlugin from "@/plugins/s3-uploader-plugin";
import * as FullStory from "@fullstory/browser";

FullStory.init({
  orgId: "o-1DCSZR-na1",
  devMode: process.env.NODE_ENV !== "production",
});

Vue.prototype.$FullStory = FullStory;
Vue.config.productionTip = false;
Vue.use(VueClipboard);
Vue.prototype.EventBus = EventBus;
Vue.prototype.$invoiceHub = InvoiceHub;
Vue.use(VueFormulate, {
  plugins: [S3UploaderPlugin],
});

configuration.init().then(() => {
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
});
